import * as currencyLibrary from "currency-library";
import React, { useEffect, useRef, useState } from "react";
import {
  Card,
  CardBody,
  CardHeader,
  Container,
  FormFeedback,
  Input,
  Label,
  Modal,
  ModalBody,
} from "reactstrap";
import BreadCrumb from "../../Components/Common/BreadCrumb";
import { Row, Col, Button } from "reactstrap";
import { MaterialReactTable } from "material-react-table";
import { handleExportData } from "../Utils/ExportToCsv";
import { useNavigate } from "react-router-dom";
import {
  formatDate,
  convertNumberOfDaysToMonthYear,
  getDayDiff,
  duration,
} from "./constants/DateFormat";
import { setDefault, storeRow, tabChange } from "../Utils/SetDefaultRowData";
import Simulate from "./Simulate";
import {
  currencyDataFormat,
  noCurrencyArrayDataFormat,
  reservationDataFormat,
  subscriptionDataFormat,
  toggleAccordion,
  fetchCustomerDetails,
} from "./constants/constantFunctions";
import { useDispatch, useSelector } from "react-redux";
import { fetchCustomerList } from "../../slices/customer/customerlist/thunk";
import { ToastContainer, toast } from "react-toastify";
import { CustomerPreview } from "./CustomerPreview";
import {
  customerColumns,
  customerSearchColumns,
} from "./constants/CustomerTableColumns";
import { Loader } from "../Utils/Loader";
import { setWelcomeToast } from "../../slices/welcomeToaster/action";
import {
  setSuccessMessage,
  setEditSuccessMessage,
  setDocumentSuccessMessage,
  setCustomerNotFoundMessage,
} from "../../slices/toastMessage/action";
import { lists } from "./constants/constantValues";
import { getCustomerData } from "./constants/ListingCustomerFunctions";
import { exportDataForCustomer } from "./constants/exportDataForCustomer";
import { PAGE_TITLES } from "../Common/constants";
import { CustomerTableCustomTableButtons } from "./CustomerTableCustomTableButtons";
import { TableForTelco } from "./TableForTelco";
import { TelcoHeaderForCustomer } from "./TelcoHeaderForCustomer";
import { searchCustomerJsonData } from "./constants/CustomerJsonObj";
import { TableForAI } from "./TableForAI";
import { getAttributeByType } from "../../slices/attribute/getattributebytype/thunk";
import CommonModal from "../Utils/CommonModal";
import { deletecustomer } from "../../slices/customer/deletecustomer/thunk";
import { bulkDelete } from "../../slices/BulkDelete/thunk";
import { MenuItem } from "@mui/material";
import { navigateToSubscribe } from "./constants/DocumentTableFunctions";
import ReactApexChart from "react-apexcharts";
import SelectField from "../Utils/SelectField";
import { useColumnSettings } from "../Utils/useColumnSettings";
import { fetchCustomerListForReservation } from "../../slices/reservations/customerlist/thunk";
import { fetchCustomerCount } from "../../slices/customer/customerTagCount/thunk";
import { TopConsumedCustomers } from "../../slices/customer/customerConsumption/thunk";
import { getView } from "../../slices/View/thunk";
import { fetchOriginalBalanceByTags } from "../../slices/customer/OriginalBalanceByTags/thunk";
import { hasPermission } from "../Utils/UtilityFunctions";

export default function ListingCustomers({ AIData, AISetTable, TableShow }) {
  const [loading, setLoading] = useState(false);
  const [renderSimulate, setRenderSimulate] = useState(false);
  const [index, setIndex] = useState(null);
  const [open, setOpen] = useState("1");
  const [activeTab, setActiveTab] = useState("0.1");
  const [isLoading, setIsLoading] = useState(false);
  const [isRefetching, setIsRefetching] = useState(false);
  const [rowCount, setRowCount] = useState(100);
  const [isError, setIsError] = useState(false);
  const [searchValue, setSearchValue] = useState();
  const [columnFilters, setColumnFilters] = useState([]);
  const [selectedValue, setSelectedValue] = useState();
  const [msisdn, setMsisdn] = useState("");
  const [imsi, setImsi] = useState("");
  const [accountNumber, setAccountNumber] = useState("");
  const [getTable, setGetTable] = useState(false);
  const [customerArray, setCustomerArray] = useState([]);
  const [modalForBulkDelete, setModalForBulkDelete] = useState(false);
  const [selectedRowsForBulkDelete, setSelectedRowsForBulkDelete] = useState();
  const [errors, setErrors] = useState({
    msisdn: "",
    imsi: "",
    accountNumber: "",
  });
  const [errorMessage, setErrorMessage] = useState(
    "Search for customer using the parameters above."
  );
  const [errorIcon, setErrorIcon] = useState("ri-user-fill");
  const rolename = localStorage.getItem("roleName");
  const isAIPath = window.location.pathname.includes("/chatbot");
  const [messageForPopUp, setMessageForPopUp] = useState("");
  const [customerId, setCustomerId] = useState();
  const [modal, setModal] = useState(false);
  const [searchExpanding, setSearchExpanding] = useState(false);
  const [custId, setCustId] = useState();
  const [selectAllCustomers, setSelectAllCustomers] = useState(false);
  const [selectedCustomer, setSelectedCustomer] = useState([]);
  const [selectedOption, setSelectedOption] = useState();
  const [series, setSeries] = useState([0, 0]);

  const checkboxRef = useRef(null);
  const isMobile = window.innerWidth <= 768;
  const operatorConfiguration = useSelector(
    (state) =>
      state?.GetOperatorSpecificConfiguration?.OperatorSpecificConfiguration
  );

  // const activeInactiveOptions =
  //   operatorConfiguration?.configurations
  //     ?.find((config) => config.name === "CustomerCategory")
  //     ?.value?.find((item) => item.key === "Categories")
  //     ?.value?.map((val) => ({ label: val, value: val })) || [];
  const activeInactiveOptions = (
    operatorConfiguration?.configurations?.CustomerCategory?.value?.Tags?.value ??
    operatorConfiguration?.configurations?.CustomerCategory?.value?.Categories?.value ??
    []
  )?.map(category => ({ label: category, value: category })) ?? [];
  // const isEIPEnabled =
  //   operatorConfiguration?.configurations
  //     ?.find((config) => config.name === "EIP")
  //     ?.value?.find((item) => item.key === "Enabled")?.value?.[0] === "True";

  const isEIPEnabled = operatorConfiguration?.configurations?.EIP?.value?.Enabled?.value === true;

  const successMessage = isEIPEnabled
    ? "Device Created Successfully"
    : "Customer Created Successfully";

  const failureMessage = isEIPEnabled
    ? "Device Updated Successfully"
    : "Customer Updated Successfully";

  const toggleModal = (id, singleOrMulti) => {
    if (singleOrMulti === "single") {
      setCustomerId(id);
      setModal(!modal);
    } else {
      setSelectedRowsForBulkDelete(id);
      setModalForBulkDelete(!modalForBulkDelete);
    }
    document.body.style.overflow = "auto";
  };
  const [pagination, setPagination] = useState({
    pageIndex: 0,
    pageSize: 10,
  });
  const current = new Date();
  const dispatch = useDispatch();
  let navigate = useNavigate();
  let simulateOrPreview = "";
  let subscriptionsArray = [];
  let noCurrencyArray = [];
  let currencyArray = [];
  let reservationDataArray = [];
  let exportData;
  // useEffect(() => {
  //   dispatch(fetchCustomerListForReservation(setLoading));
  // }, [dispatch]);
  const toggle = toggleAccordion(open, setOpen);
  const rawPermissions = useSelector(
    (state) => state.permissions.permissionsMap
  );

  const permissionsMap = new Map(
    rawPermissions.map(([key, value]) => [key, new Set(value)])
  );
  const showWelcomeToast = useSelector(
    (state) => state.welcomeToast.showWelcomeToast
  );
  const showSuccessMessage = useSelector(
    (state) => state.SuccessToast.showSuccessMessage
  );
  const showDocumentSuccessMessage = useSelector(
    (state) => state.SuccessToast.showDocumentSuccessMessage
  );
  const showCustomerNotFoundMessage = useSelector(
    (state) => state.SuccessToast.showCustomerNotFoundMessage
  );
  const showEditSuccessMessage = useSelector(
    (state) => state.SuccessToast.showEditSuccessMessage
  );
  const reservationPermission = hasPermission(permissionsMap, "reservation", "reservation")
  const stationPermission = hasPermission(permissionsMap, "station", "station")
  const customerPermission = hasPermission(permissionsMap, "customer", "customer")
  const orderPermission = hasPermission(permissionsMap, "customer", "order")
  const subscriptionPermission = hasPermission(permissionsMap, "customer", "subscription")
  // const allCustomerData = useSelector(
  //   (state) => state.CustomerAllData.customerListForReservation
  // );
  let list = lists;
  const stationData = useSelector((state) => state.Stations.station);
  const reservationData = useSelector(
    (state) => state.Reservations.reservations
  );
  const customerData = useSelector(
    (state) => state.FetchCustomer.fetchCustomer
  );
  const fetchCustomerSummaryData = useSelector(
    (state) => state.Simulate.simulate
  );
  noCurrencyArray = noCurrencyArrayDataFormat(
    fetchCustomerSummaryData,
    noCurrencyArray
  );
  let attributeDataArray = customerData?.customerInfo?.attributeList || [];

  currencyArray = currencyDataFormat(fetchCustomerSummaryData, currencyArray);
  subscriptionsArray = subscriptionDataFormat(customerData, subscriptionsArray);
  reservationDataArray = reservationDataFormat(
    reservationData,
    customerData,
    stationData,
    reservationDataArray
  );
  const customers = useSelector(
    (state) => state?.CustomerList?.customerList?.Customers
  );
  const TotalCustomers = useSelector(
    (state) => state?.CustomerList?.customerList
  );
  const columns = customerColumns(
    selectAllCustomers,
    setSelectAllCustomers,
    customers,
    setSelectedCustomer,
    selectedCustomer,
    checkboxRef,
    isMobile,
    operatorConfiguration
  );
  const customerListingVar =
    operatorConfiguration?.configurations?.CustomerRetrieval?.value?.CustomerListing?.value === true
      ? true
      : false;
  useEffect(() => {
    if (checkboxRef.current) {
      checkboxRef.current.indeterminate =
        selectedCustomer?.length > 0 &&
        selectedCustomer?.length < customers?.length;
    }
    setSelectAllCustomers(
      selectedCustomer?.length > 0 &&
      customers?.length > 0 &&
      selectedCustomer?.length === customers?.length
    );
  }, [selectedCustomer, customers?.length, setSelectAllCustomers]);

  useEffect(() => {
    if (customerListingVar) {
      const [lastFilter] = [...columnFilters].slice(-1);
      if (lastFilter) {
        const selectedId =
          lastFilter.id === "FullName" ? "Name" : lastFilter.id;

        const value =
          lastFilter.id === "Tags" ? [lastFilter.value] : lastFilter.value;

        setSelectedValue(selectedId);
        setSearchValue(value);

        dispatch(
          fetchCustomerList(
            setLoading,
            1,
            TotalCustomers?.TotalCount,
            selectedId,
            value
          )
        );
      } else {
        if (!customerListingVar) {
          dispatch(fetchCustomerList(setLoading, 1, isEIPEnabled ? 10 : 5));
        } else {
          setSearchValue("");
          dispatch(fetchCustomerList(setLoading, 1, pagination.pageSize));
        }
      }
    }
  }, [columnFilters]);

  useEffect(() => {
    dispatch(getAttributeByType("customer", setLoading));
  }, []);

  const searchableAttributes = useSelector(
    (state) => state.GetAttributeByType.getSearchableAttribute
  );
  const integerAndTextAttributes = searchableAttributes.filter((item) => {
    return item.valueType === "integer" || item.valueType === "string";
  });
  const [searchFields, setSearchFields] = useState([]);
  useEffect(() => {
    if (!customerListingVar) {
      dispatch(fetchCustomerList(setLoading, 1, isEIPEnabled ? 10 : 5));
    }
  }, [rolename, dispatch, isEIPEnabled]);

  useEffect(() => {
    if (integerAndTextAttributes.length > 0) {
      setSearchFields(
        integerAndTextAttributes.map((attr) => ({
          name: attr.name,
          value: "",
          touched: false,
        }))
      );
    }
  }, [searchableAttributes]);

  useEffect(() => {
    if (showWelcomeToast) {
      toast.success(`Welcome ${localStorage.getItem("userName")}`);
      dispatch(setWelcomeToast(false));
    }
    if (showSuccessMessage) {
      toast.success(successMessage);
      dispatch(setSuccessMessage(false));
    }
    if (showEditSuccessMessage) {
      toast.success(failureMessage);
      dispatch(setEditSuccessMessage(false));
    }
    if (showDocumentSuccessMessage) {
      toast.success(`Subscription Created Successfully`);
      dispatch(setDocumentSuccessMessage(false));
    }
    if (showCustomerNotFoundMessage) {
      toast.error("Customer Not Found");
      dispatch(setCustomerNotFoundMessage(false));
    }
  }, [
    showSuccessMessage,
    showDocumentSuccessMessage,
    showWelcomeToast,
    showCustomerNotFoundMessage,
    dispatch,
  ]);

  useEffect(() => {
    if (customerListingVar) {
      setIsLoading(true);
      setIsRefetching(true);
      const fetchData = async () => {
        setIsLoading(true);
        setIsRefetching(true);

        try {
          await dispatch(
            fetchCustomerList(
              setLoading,
              pagination.pageIndex + 1,
              pagination.pageSize
            )
          );
          setRowCount(customers.length);
        } catch (error) {
          setIsError(true);
        } finally {
          setIsLoading(false);
          setIsRefetching(false);
        }
      };
      fetchData();
    }
  }, [pagination.pageIndex, pagination.pageSize]);
  // if (customers) {
  //   exportData = exportDataForCustomer(allCustomerData);
  // }

  const searchCustomerData = useSelector(
    (state) => state.SearchedCustomer.searchCustomer
  );
  let searchedCustomerDataJsonObj;
  if (searchCustomerData) {
    searchedCustomerDataJsonObj = searchCustomerJsonData(
      searchCustomerData,
      rolename
    );
  }
  const searchColumns = customerSearchColumns();

  useEffect(() => {
    dispatch(getView(setLoading));
  }, [dispatch]);

  const {
    settingsModalOpen,
    viewColumns,
    toggleSettingsModal,
    SettingsSidebar,
    CustomViewModal,
  } = useColumnSettings("customer", searchColumns);

  const toggleModals = () => {
    setRenderSimulate((prev) => !prev);
  };

  // const pageTitle = rolename === 'telcoAdmin' ? PAGE_TITLES.TELCO_CUSTOMER : PAGE_TITLES.CUSTOMER_LIST;
  // const currencyConfig = operatorConfiguration?.configurations?.find(
  //   (config) => config?.name === "DefaultCurrency"
  // )?.value[0]?.value[0];
  const currencyConfig = operatorConfiguration?.configurations?.DefaultCurrency?.value?.CurrencyCode?.value
  const allCurrencies = currencyLibrary.getAll();
  const DefaultCurrency =
    allCurrencies?.find((curr) => curr.isoCode === currencyConfig) ||
    allCurrencies?.find((curr) => curr.isoCode === "USD");
  const pageTitle = isEIPEnabled
    ? (rolename === "telcoAdmin" || rolename === "telcoOperationUser" || rolename === "telcoBusinessUser")
      ? PAGE_TITLES.TELCO_CUSTOMER_EIP
      : "Device List"
    : (rolename === "telcoAdmin" || rolename === "telcoOperationUser" || rolename === "telcoBusinessUser")
      ? PAGE_TITLES.TELCO_CUSTOMER
      : "Customer List";

  const customerListTitle = isEIPEnabled
    ? PAGE_TITLES.CUSTOMER_LIST_EIP
    : PAGE_TITLES.CUSTOMER_LIST;

  const moduleTitle = isEIPEnabled
    ? PAGE_TITLES.CUSTOMER_LIST_EIP
    : PAGE_TITLES.CUSTOMER_LIST;

  const tags = operatorConfiguration?.configurations?.CustomerCategory?.value?.Tags?.value ??
  operatorConfiguration?.configurations?.CustomerCategory?.value?.Categories?.value ??
  []
  useEffect(() => {
    if (activeInactiveOptions?.length) {
      const firstValue = activeInactiveOptions[0]?.value;
      setSelectedOption(firstValue);
      dispatch(fetchCustomerCount(setLoading, firstValue));
    }
    dispatch(TopConsumedCustomers(setLoading));
    dispatch(fetchOriginalBalanceByTags(setLoading, tags));
  }, [dispatch]);

  const tagsCount = useSelector(
    (state) => state?.fetchCustomerCount?.customerTagStatusCount
  );
  const barData = useSelector(
    (state) => state?.TopConsumedCustomers?.TopConsumedCustomers
  );
  const pieData = useSelector(
    (state) => state?.fetchOriginalBalanceByTags?.OriginalBalanceByTags
  );
  const sortedPieData = [...pieData]
    ?.map((tag) => ({ ...tag, energyCost: Math.abs(tag?.energyCost) }))
    ?.sort((a, b) => b?.energyCost - a?.energyCost);

  useEffect(() => {
    if (selectedOption) {
      const count = tagsCount?.find((tag) => tag.tag === selectedOption);
      setSeries([count?.activeCount ?? 0, count?.inactiveCount ?? 0]);
    }
  }, [selectedOption, tagsCount]);

  const handleSelectChange = (value) => {
    dispatch(fetchCustomerCount(setLoading, value));
  };
  const options = {
    chart: {
      height: 200,
      width: 200,
      type: "donut",
    },
    labels: ["Active", "In Active"],
    legend: {
      show: false,
    },
    dataLabels: {
      enabled: false,
      dropShadow: {
        enabled: false,
      },
    },
    colors: ["#66A8E3", "#F6A351"], // Active in green, Inactive in red
  };
  const expectedValue = 3000;

  const barSeries = [
    {
      name: "Power Consumed (kWh)",
      type: "bar",
      data: barData?.map((data) => ({
        x: data?.customerName,
        y: data?.totalConsumed,
      })),
    },
    {
      name: "Energy Consumption Threshold",
      type: "line",
      data: barData?.map((data) => ({
        x: data?.customerName,
        y: expectedValue,
      })),
    },
  ];

  const barOptions = {
    chart: {
      type: "line",
      toolbar: { show: false },
    },
    plotOptions: {
      bar: { columnWidth: "30%" },
    },
    dataLabels: { enabled: false },
    legend: {
      show: true, // Ensure legend is visible
      showForSingleSeries: false,
      customLegendItems: [
        "Power Consumed (kWh)",
        "Energy Consumption Threshold",
      ],
      markers: {
        fillColors: ["#51d28c", "#FF0000"],
      },
      offsetX: 20,
    },
    stroke: {
      width: [5, 2, 6], // Thinner dashed line (2px)
      curve: "straight",
      dashArray: [0, 8, 5], // Second series is dashed
    },
    xaxis: {
      type: "category",
    },
    yaxis: {
      title: {
        text: "Power Consumption (kWh)",
      },
    },
    colors: ["#51d28c", "#FF0000"],
  };

  const generateUniqueColors = (count) => {
    const baseColors = ["#84BFFF", "#4BD495", "#FFC854"];
    const generatedColors = [];
    const extraCount = Math.max(0, count - baseColors.length);

    for (let i = 0; i < extraCount; i++) {
      const hue = (i * 360) / extraCount;
      generatedColors.push(`hsl(${hue}, 65%, 55%)`);
    }
    return [...baseColors.slice(0, count), ...generatedColors];
  };
  const pieseries =
    sortedPieData?.map((data) => Math.abs(data?.energyCost)) || [];
  const colors = generateUniqueColors(sortedPieData?.length || 0);
  // const pieseries = [5000, 3000, 2000]; // Cost breakdown in dollars
  const pieoptions = {
    chart: {
      height: 300,
      type: "pie",
    },
    // labels: ['Data Centers', 'RAN Devices', 'IoT'],
    labels: sortedPieData?.map((data) => data?.tag) || [],
    legend: {
      show: false, // Show legend for better understanding
      position: "bottom",
    },
    dataLabels: {
      enabled: false, // Enable data labels
      formatter: function (val, opts) {
        return `${DefaultCurrency?.symbol}${opts.w.config.series[
          opts.seriesIndex
        ].toLocaleString()}`;
      },
      style: {
        fontSize: "14px",
        fontWeight: "bold",
        colors: ["#fff"],
      },
    },
    tooltip: {
      y: {
        formatter: function (value) {
          return `${DefaultCurrency?.symbol}${value.toLocaleString()}`; // Format as currency
        },
      },
    },
    colors: colors, // Custom colors
  };

  return (
    <React.Fragment>
      {!isAIPath ? (
        <div id="csms" className="page-content bg-white pb-0 mb-0">
          <Container fluid>
            <BreadCrumb
              title={pageTitle}
              pageTitle={customerListTitle}
              moduleTitle={moduleTitle}
            />
            <h5 className="rv-page-title p-2">{pageTitle}</h5>
            <Row style={{ marginTop: "10px" }}>
              <ToastContainer position="top-center" />

              <Col lg={12}>
                <div className="listingjs-table " id="customerList">
                  {isEIPEnabled && (
                    <Row className="mb-3">
                      <Col lg={12}>
                        <Row className="gy-0 ms-0 me-0">
                          <Col xxl={4} md={6}>
                            <Card className="border rounded-1 px-1 py-1 my-0 bg-white h-100">
                              <CardHeader>
                                Active vs Inactive Devices
                              </CardHeader>
                              <CardBody className="d-flex flex-column">
                                <SelectField
                                  className={"mb-4"}
                                  defaultValue={activeInactiveOptions[0]}
                                  value={selectedOption?.label}
                                  options={activeInactiveOptions}
                                  handleChange={(value) => {
                                    setSelectedOption(value?.value);
                                    handleSelectChange(value?.value);
                                  }}
                                />
                                <div className="d-flex justify-content-center align-items-center mt-2">
                                  {!(series[0] === 0 && series[1] === 0) ? (
                                    <>
                                      <ReactApexChart
                                        dir="ltr"
                                        className="apex-charts flex-grow-1"
                                        series={series}
                                        options={options}
                                        type="donut"
                                        height={230}
                                        width={230}
                                      />
                                      <div>
                                        {/* <h5 className="text-black-50 mb-4">Monthly Trend</h5> */}
                                        <div className=" p-2 text-center mb-2">
                                          <div className="d-flex align-items-center justify-content-center mb-2">
                                            <span
                                              className="rounded-circle d-inline-block me-2"
                                              style={{
                                                width: "12px",
                                                height: "12px",
                                                backgroundColor: "#66A8E3",
                                              }}
                                            ></span>
                                            <span className="text-muted">
                                              Active Devices
                                            </span>
                                          </div>
                                          <div
                                            className="bg-light p-2 rounded d-inline-block"
                                            style={{ width: "85px" }}
                                          >
                                            <span className="text-success fw-bold">
                                              {series[0]}
                                            </span>
                                          </div>
                                        </div>
                                        <div className=" p-2 text-center ">
                                          <div className="d-flex align-items-center justify-content-center mb-2">
                                            <span
                                              className="rounded-circle d-inline-block me-2"
                                              style={{
                                                width: "12px",
                                                height: "12px",
                                                backgroundColor: "#F6A351",
                                              }}
                                            ></span>
                                            <span className="text-muted">
                                              Inactive Devices
                                            </span>
                                          </div>
                                          <div
                                            className="bg-light p-2 rounded d-inline-block"
                                            style={{ width: "85px" }}
                                          >
                                            <span className="text-danger fw-bold">
                                              {series[1]}
                                            </span>
                                          </div>
                                        </div>
                                      </div>
                                    </>
                                  ) : (
                                    <div
                                      className="d-flex justify-content-center align-items-center text-center fs-5"
                                      style={{ minHeight: "200px" }}
                                    >
                                      <div>No devices Available</div>
                                    </div>
                                  )}
                                </div>
                              </CardBody>
                            </Card>
                          </Col>

                          <Col xxl={4} md={6}>
                            <Card className="border rounded-1 px-1 py-1 my-0 bg-white h-100">
                              <CardHeader>
                                High Power Consuming Sites (Top 4){" "}
                              </CardHeader>
                              <CardBody>
                                <ReactApexChart
                                  dir="ltr"
                                  className="apex-charts"
                                  options={barOptions}
                                  series={barSeries}
                                  type="line"
                                  height={350}
                                // width={403}
                                />
                              </CardBody>
                            </Card>
                          </Col>

                          {/* <Col xxl={4} md={6}>
                                                        <Card className="h-100">
                                                            <CardHeader>Energy Cost Breakdown</CardHeader>
                                                            <CardBody className="d-flex flex-column">
                                                                <div className="d-flex justify-content-center align-items-center mt-2">
                                                                    <ReactApexChart
                                                                        dir="ltr"
                                                                        className="apex-charts flex-grow-1"
                                                                        series={pieseries}
                                                                        options={pieoptions}
                                                                        type="pie"
                                                                        height={230}
                                                                    />
                                                                    <div>
                                                                        <h5 className="text-black-50 mb-4">Monthly Trend</h5>
                                                                        {/* <div className=" rounded p-2 text-center  mb-2">
                                                                            <div className="d-flex align-items-center justify-content-center mb-2">
                                                                                <span
                                                                                    className="rounded-circle d-inline-block me-2"
                                                                                    style={{ width: "12px", height: "12px", backgroundColor: '#4BD495' }}
                                                                                ></span>
                                                                                <span className="text-muted">RAN Device</span>
                                                                            </div>
                                                                            <div className="bg-light p-2 rounded d-inline-block">
                                                                                <span className="text-success fw-bold">
                                                                                    <i className="ri-arrow-up-line align-middle"></i> 16.24 %
                                                                                </span>
                                                                            </div>
                                                                        </div>
                                                                        <div className=" rounded p-2 text-center  mb-2">
                                                                            <div className="d-flex align-items-center justify-content-center mb-2">
                                                                                <span
                                                                                    className="rounded-circle d-inline-block me-2"
                                                                                    style={{ width: "12px", height: "12px", backgroundColor: '#84BFFF' }}
                                                                                ></span>
                                                                                <span className="text-muted">Data Center</span>
                                                                            </div>
                                                                            <div className="bg-light p-2 rounded d-inline-block">
                                                                                <span className="text-danger fw-bold">
                                                                                    <i className="ri-arrow-down-line align-middle"></i> 10.24 %
                                                                                </span>
                                                                            </div>
                                                                        </div>
                                                                        <div className=" rounded p-2 text-center ">
                                                                            <div className="d-flex align-items-center justify-content-center mb-2">
                                                                                <span
                                                                                    className="rounded-circle d-inline-block me-2"
                                                                                    style={{ width: "12px", height: "12px", backgroundColor: '#FFC854' }}
                                                                                ></span>
                                                                                <span className="text-muted">IoT</span>
                                                                            </div>
                                                                            <div className="bg-light p-2 rounded d-inline-block">
                                                                                <span className="text-danger fw-bold">
                                                                                    <i className="ri-arrow-down-line align-middle"></i> 9.24 %
                                                                                </span>
                                                                            </div>
                                                                        </div>
                                                                            {pieData.map((item, index) => {
                                                                            const isUp =true;
                                                                            return (
                                                                                <div key={index} className="rounded p-2 text-center mb-2">
                                                                                    <div className="d-flex align-items-center justify-content-center mb-2">
                                                                                        <span
                                                                                            className="rounded-circle d-inline-block me-2"
                                                                                            style={{ width: "12px", height: "12px", backgroundColor: pieoptions?.colors?.[index] }}
                                                                                        ></span>
                                                                                        <span className="text-muted">{item?.tag}</span>
                                                                                    </div>
                                                                                    <div className="bg-light p-2 rounded d-inline-block">
                                                                                        <span className={`fw-bold ${isUp ? "text-success" : "text-danger"}`}>
                                                                                           {item?.energyCost} %
                                                                                        </span>
                                                                                    </div>
                                                                                </div>
                                                                            );
                                                                        })}
                                                                    </div>
                                                                </div>
                                                            </CardBody>
                                                        </Card>
                                                    </Col> */}
                          <Col xxl={4} md={6}>
                            <Card className="border rounded-1 px-0 py-1 my-0 bg-white h-100">
                              <CardHeader>Energy Cost Breakdown</CardHeader>
                              <CardBody className="mt-2 pt-2 pb-0 mb-0">
                                <div className="d-flex justify-content-between">
                                  {/* Pie Chart Section */}
                                  <div
                                    style={{
                                      flex: "0 0 60%",
                                      display: "flex",
                                      justifyContent: "center",
                                    }}
                                    className="mt-5"
                                  >
                                    <ReactApexChart
                                      dir="ltr"
                                      className="apex-charts"
                                      series={pieseries}
                                      options={pieoptions}
                                      type="pie"
                                      height={230}
                                    />
                                  </div>

                                  {/* Legend Section */}
                                  <div
                                    className="mt-5 mb-0 pe-2"
                                    style={{
                                      maxHeight: "300px", // Adjust as needed
                                      overflowY: "auto",
                                    }}
                                  >
                                    {sortedPieData.map((item, index) => {
                                      const isUp = item.energyCost >= 0;
                                      return (
                                        <div
                                          key={index}
                                          className="d-flex flex-column justify-content-between mb-2"
                                        >
                                          <div className="d-flex align-items-center mb-1">
                                            <span
                                              className="rounded-circle d-inline-block me-1"
                                              style={{
                                                width: "12px",
                                                height: "12px",
                                                backgroundColor: pieoptions.colors[index],
                                              }}
                                            ></span>
                                            <span className="text-muted ms-2">
                                              {item.tag}
                                            </span>
                                          </div>

                                          <div
                                            className={`ms-3 bg-light p-2 rounded d-inline-block fw-bold ${
                                              isUp ? "text-success" : "text-danger"
                                            }`}
                                            style={{ width: "85px" }}
                                          >
                                            <span className="ms-2">
                                              {DefaultCurrency?.symbol} {Math.abs(item?.energyCost)}
                                            </span>
                                          </div>
                                        </div>
                                      );
                                    })}
                                  </div>
                                </div>
                              </CardBody>
                            </Card>
                          </Col>
                        </Row>
                      </Col>
                    </Row>
                  )}
                  {/* <TelcoHeaderForCustomer setCustId={setCustId} custId={custId} searchCustomerData={searchCustomerData} setRenderSimulate={setRenderSimulate} stationPermission={stationPermission} reservationPermission={reservationPermission} customerPermission={customerPermission} searchFields={searchFields} setSearchFields={setSearchFields} integerAndTextAttributes={integerAndTextAttributes} setErrorMessage={setErrorMessage} setErrorIcon={setErrorIcon} msisdn={msisdn} imsi={imsi} accountNumber={accountNumber} errors={errors} dispatch={dispatch} setLoading={setLoading} setGetTable={setGetTable} setMsisdn={setMsisdn} setImsi={setImsi} setAccountNumber={setAccountNumber} navigate={navigate} setErrors={setErrors} searchExpanding={searchExpanding} setSearchExpanding={setSearchExpanding} /> */}
                  <Row className="d-flex align-items-sm-start mx-0 mb-5">
                    <Col lg={12} className="">
                      {customerListingVar ? (
                        <div className="container-fluid px-0">
                          <div className="disable-margin-card table-responsive table-customer border w-100">
                            {customers ? (
                              <MaterialReactTable
                                //   icons={{
                                //       DragHandleIcon: () => (
                                //           <i className="ri-drag-move-fill" />
                                //       ),
                                //   }}
                                renderTopToolbarCustomActions={({ table }) => (
                                  <CustomerTableCustomTableButtons
                                    integerAndTextAttributes={
                                      integerAndTextAttributes
                                    }
                                    selectedCustomer={selectedCustomer}
                                    toggleModal={toggleModal}
                                    setMessageForPopUp={setMessageForPopUp}
                                    setCustomerArray={setCustomerArray}
                                    table={table}
                                    navigate={navigate}
                                    customerPermission={customerPermission}
                                    // exportData={exportData}
                                    custId={customerId}
                                    dispatch={dispatch}
                                    setLoading={setLoading}
                                    setGetTable={setGetTable}
                                    setErrors={setErrors}
                                    setErrorMessage={setErrorMessage}
                                    setErrorIcon={setErrorIcon}
                                    searchFields={searchFields}
                                    setSearchFields={setSearchFields}
                                    setRenderSimulate={setRenderSimulate}
                                    stationPermission={stationPermission}
                                    reservationPermission={
                                      reservationPermission
                                    }
                                    searchCustomerData={searchCustomerData}
                                    setCustId={setCustomerId}
                                    setSearchExpanding={setSearchExpanding}
                                  />
                                )}
                                displayColumnDefOptions={{
                                  "mrt-row-actions": {
                                    header: "",
                                    enableHiding: true,
                                    size: isMobile ? 60 : 52,
                                    grow: true,
                                    position: 2,
                                  },
                                }}
                                defaultColumn={{
                                  minSize: 1,
                                  maxSize: 9001,
                                  size: 260,
                                  muiTableBodyCellProps: {
                                    sx: {
                                      fontFamily: "Inter,sans-serif",
                                    },
                                  },
                                  muiTableHeadCellProps: {
                                    sx: {
                                      fontFamily: "Inter,sans-serif",
                                      color: "#343A40",
                                      borderTop:
                                        "1px solid rgba(224, 224, 224, 1)",
                                    },
                                  },
                                }}
                                layoutMode="grid"
                                muiTableDetailPanelProps={{
                                  sx: {
                                    fontFamily: "Inter,sans-serif",
                                  },
                                }}
                                enableGlobalFilter={false}
                                enableColumnOrdering={false}
                                enableColumnDragging={false}
                                enableDensityToggle={false}
                                enableColumnVisibility={false}
                                enableFullScreenToggle={false}
                                enableHiding={false}
                                enableColumnFilters
                                enableColumnActions={false}
                                positionToolbarAlertBanner="none"
                                columns={columns}
                                data={
                                  !getTable
                                    ? customers
                                    : searchedCustomerDataJsonObj
                                }
                                manualPagination={true}
                                onPaginationChange={setPagination}
                                {...(searchValue === ""
                                  ? { rowCount: TotalCustomers?.TotalCount }
                                  : { rowCount: TotalCustomers?.Count })}
                                positionGlobalFilter="right"
                                muiSearchTextFieldProps={{
                                  placeholder: `Search ${customers.length} rows`,
                                  sx: { minWidth: "300px" },
                                  variant: "outlined",
                                }}
                                manualFiltering
                                onColumnFiltersChange={setColumnFilters}
                                enableGlobalFilterModes
                                state={{
                                  isLoading,
                                  ...(searchValue === "" ? { pagination } : {}),
                                  showProgressBars: isRefetching,
                                  columnFilters,
                                  showColumnFilters: true,
                                }}
                                muiSelectCheckboxProps={{
                                  color: "warning",
                                }}
                                muiSelectAllCheckboxProps={{
                                  color: "warning",
                                }}
                                enableRowActions={true}
                                initialState={{
                                  columnVisibility: {
                                    "mrt-row-expand": false,
                                    // "Tags":false,
                                    Email: isEIPEnabled ? false : true,
                                    Mobile: false,
                                  },
                                  columnOrder: [
                                    "checkbox",
                                    "mrt-row-actions",
                                    "CustomerId",
                                    "FullName",
                                    "Email",
                                    "Mobile",
                                    "Address",
                                    "Tags",
                                  ],
                                }}
                                renderRowActionMenuItems={({
                                  closeMenu,
                                  row,
                                }) => [
                                    customerPermission &&
                                      customerPermission?.has("view")
                                      ? (
                                        <MenuItem
                                          className="row-options  pb-3"
                                          key="view"
                                          onClick={() => {
                                            simulateOrPreview = "View";
                                            navigate(
                                              `/view-customer/${row.original.CustomerId}`
                                            );
                                          }}
                                        >
                                          <i className="ri  ri-eye-line me-3" />{" "}
                                          <span className="me-4">View</span>
                                        </MenuItem>
                                      ) : null,
                                    customerPermission &&
                                      customerPermission?.has(
                                        "update"
                                      ) ? (
                                      <MenuItem
                                        className="row-options  pb-3"
                                        key="edit"
                                        onClick={() => {
                                          navigate(
                                            `/update-customer/${row.original.CustomerId}`
                                          );
                                        }}
                                      >
                                        <i className="ri-edit-box-line me-3" />
                                        <span className="me-4">Edit</span>
                                      </MenuItem>
                                    ) : null,
                                    customerPermission && customerPermission?.has("simulate") ?
                                      <MenuItem
                                        className="row-options pb-3"
                                        key="delete"
                                        onClick={(e) => {
                                          simulateOrPreview = "Simulate";
                                          fetchCustomerDetails(
                                            dispatch,
                                            setLoading,
                                            setRenderSimulate,
                                            row,
                                            simulateOrPreview
                                          );
                                          storeRow(row, setIndex, index),
                                            setDefault(row.index, setActiveTab);
                                          closeMenu();
                                        }}
                                      >
                                        <i className=" ri ri-signal-tower-line me-3" />{" "}
                                        <span className="me-4">Simulate</span>
                                      </MenuItem> : null,
                                    // <MenuItem
                                    //   className="row-options pb-3"
                                    //   key="preview"
                                    //   onClick={(e) => {
                                    //     simulateOrPreview = "Preview";
                                    //     e.stopPropagation();
                                    //     getCustomerData(
                                    //       row,
                                    //       simulateOrPreview,
                                    //       setLoading,
                                    //       stationPermission,
                                    //       reservationPermission,
                                    //       customerPermission,
                                    //       setRenderSimulate,
                                    //       dispatch
                                    //     );
                                    //     row.toggleExpanded();
                                    //     storeRow(row, setIndex, index),
                                    //       setDefault(row.index, setActiveTab),
                                    //       closeMenu();
                                    //   }}
                                    // >
                                    //   <i className="ri-survey-line me-3" />
                                    //   <span className="me-4">Preview</span>
                                    // </MenuItem>,
                                    (
                                      hasPermission(permissionsMap, "customer", "subscription", "create") || hasPermission(permissionsMap, "customer", "order", "create")) ? (
                                      <MenuItem
                                        className="row-options pb-3"
                                        key="subscribe"
                                        onClick={() => {
                                          navigateToSubscribe(
                                            row,
                                            dispatch,
                                            navigate
                                          );
                                        }}
                                      >
                                        <i className="ri-add-circle-line me-3 "></i>{" "}
                                        <span className="me-4">Subscribe</span>
                                      </MenuItem>
                                    ) : null,
                                    customerPermission &&
                                      customerPermission?.has(
                                        "delete"
                                      ) ? (
                                      <MenuItem
                                        className="row-options pb-3"
                                        key="close"
                                        onClick={() => {
                                          setMessageForPopUp(
                                            `Are you sure you want to delete the Customer "${row.original.CustomerId}"?`
                                          );
                                          toggleModal(row, "single");
                                          setCustomerId(row.original.CustomerId);
                                          closeMenu();
                                        }}
                                      >
                                        <i className="ri ri-delete-bin-5-line me-3" />{" "}
                                        <span className="me-4">Delete</span>
                                      </MenuItem>
                                    ) : null,
                                  ]}
                                renderDetailPanel={({ row }) => (
                                  <React.Fragment>
                                    {useEffect(() => {
                                      row.toggleExpanded(false);
                                    }, [pagination])}
                                    {renderSimulate ? (
                                      <Simulate row={row} />
                                    ) : (
                                      <div className="preview-customer-1">
                                        <CustomerPreview
                                          customerData={customerData}
                                          row={row}
                                          activeTab={activeTab}
                                          setActiveTab={setActiveTab}
                                          tabChange={tabChange}
                                          open={open}
                                          setOpen={setOpen}
                                          toggle={toggle}
                                          noCurrencyArray={noCurrencyArray}
                                          currencyArray={currencyArray}
                                          fetchCustomerSummaryData={
                                            fetchCustomerSummaryData
                                          }
                                          reservationDataArray={
                                            reservationDataArray
                                          }
                                          duration={duration}
                                          customerAttributeData={
                                            customerData?.customerInfo
                                              ?.attributeList
                                          }
                                          subscriptionsArray={
                                            subscriptionsArray
                                          }
                                          convertNumberOfDaysToMonthYear={
                                            convertNumberOfDaysToMonthYear
                                          }
                                          formatDate={formatDate}
                                          getDayDiff={getDayDiff}
                                          current={current}
                                        />
                                      </div>
                                    )}
                                  </React.Fragment>
                                )}
                              />
                            ) : (
                              <MaterialReactTable
                                renderTopToolbarCustomActions={({ table }) => (
                                  <CustomerTableCustomTableButtons
                                    table={table}
                                    navigate={navigate}
                                    customerPermission={customerPermission}
                                    // exportData={exportData}
                                  />
                                )}
                                positionToolbarAlertBanner="none"
                                muiTableHeadCellProps={{
                                  sx: {
                                    fontFamily: "Inter,sans-serif",
                                  },
                                }}
                                muiTableBodyCellProps={{
                                  sx: {
                                    fontFamily: "Inter,sans-serif",
                                  },
                                }}
                                muiTableDetailPanelProps={{
                                  sx: {
                                    fontFamily: "Inter,sans-serif",
                                  },
                                }}
                                initialState={{
                                  columnVisibility: {
                                    "mrt-row-expand": false,
                                    // "Tags":false,
                                    Email: isEIPEnabled ? false : true,
                                    Mobile: false,
                                  },
                                  columnOrder: [
                                    "checkbox",
                                    "mrt-row-actions",
                                    "CustomerId",
                                    "FullName",
                                    "Email",
                                    "Mobile",
                                    "Address",
                                    "Tags",
                                  ],
                                }}
                                muiSelectCheckboxProps={{
                                  color: "warning",
                                }}
                                muiSelectAllCheckboxProps={{
                                  color: "warning",
                                }}
                                columns={columns}
                                data={
                                  !getTable ? [] : searchedCustomerDataJsonObj
                                }
                                enableRowActions={true}
                                enableColumnOrdering={false}
                                enableColumnDragging={false}
                                enableDensityToggle={false}
                                displayColumnDefOptions={{
                                  "mrt-row-actions": {
                                    header: "",
                                    enableHiding: true,
                                  },
                                }}
                                enablePagination={false}
                                state={{
                                  showColumnFilters: true,
                                }}
                              />
                            )}
                            <CommonModal
                              messageForPopUp={messageForPopUp}
                              toggle={() => {
                                if (modal) {
                                  toggleModal(customerId, "single");
                                } else {
                                  toggleModal(
                                    selectedRowsForBulkDelete,
                                    "multi"
                                  );
                                }
                              }}
                              open={
                                modalForBulkDelete ? modalForBulkDelete : modal
                              }
                              buttonText={"Delete"}
                              modalAction={() => {
                                if (modal) {
                                  dispatch(
                                    deletecustomer(
                                      customerId,
                                      setLoading,
                                      1,
                                      pagination
                                    )
                                  );
                                  toggleModal(customerId, "single");
                                } else {
                                  let jsonObj = {
                                    ids: customerArray,
                                    type: "Customer",
                                  };
                                  dispatch(
                                    bulkDelete(
                                      jsonObj,
                                      setLoading,
                                      pagination?.pageIndex + 1,
                                      pagination?.pageSize
                                    )
                                  );
                                  setSelectAllCustomers(false);
                                  setSelectedCustomer([]);
                                  toggleModal(
                                    selectedRowsForBulkDelete,
                                    "multi"
                                  );
                                }
                              }}
                              modalHeader={`Delete ${isEIPEnabled ? "Device" : "Customer"
                                }`}
                            />
                          </div>
                        </div>
                      ) : (
                        <TableForTelco
                          messageForPopUp={messageForPopUp}
                          modal={modal}
                          customerId={customerId}
                          errorMessage={errorMessage}
                          errorIcon={errorIcon}
                          getTable={getTable}
                          searchColumns={searchColumns}
                          searchData={searchedCustomerDataJsonObj}
                          orderPermission={orderPermission}
                          customerPermission={customerPermission}
                          navigate={navigate}
                          dispatch={dispatch}
                          setRenderSimulate={setRenderSimulate}
                          setLoading={setLoading}
                          simulateOrPreview={simulateOrPreview}
                          index={index}
                          setIndex={setIndex}
                          setActiveTab={setActiveTab}
                          fetchCustomerDetails={fetchCustomerDetails}
                          stationPermission={stationPermission}
                          reservationPermission={reservationPermission}
                          getCustomerData={getCustomerData}
                          storeRow={storeRow}
                          setDefault={setDefault}
                          renderSimulate={renderSimulate}
                          pagination={pagination}
                          customerData={customerData}
                          activeTab={activeTab}
                          tabChange={tabChange}
                          setOpen={setOpen}
                          toggle={toggle}
                          noCurrencyArray={noCurrencyArray}
                          currencyArray={currencyArray}
                          fetchCustomerSummaryData={fetchCustomerSummaryData}
                          reservationDataArray={reservationDataArray}
                          duration={duration}
                          subscriptionsArray={subscriptionsArray}
                          convertNumberOfDaysToMonthYear={
                            convertNumberOfDaysToMonthYear
                          }
                          formatDate={formatDate}
                          getDayDiff={getDayDiff}
                          current={current}
                          setGetTable={setGetTable}
                          searchExpanding={searchExpanding}
                          setSearchExpanding={setSearchExpanding}
                          toggleModal={toggleModal}
                          setMessageForPopUp={setMessageForPopUp}
                          setCustomerId={setCustomerId}
                          TotalCustomers={TotalCustomers}
                          viewColumns={viewColumns}
                          toggleSettingsModal={toggleSettingsModal}
                          setErrors={setErrors}
                          integerAndTextAttributes={integerAndTextAttributes}
                          setErrorMessage={setErrorMessage}
                          setErrorIcon={setErrorIcon}
                          searchFields={searchFields}
                          setSearchFields={setSearchFields}
                          searchCustomerData={searchCustomerData}
                          handleExportData={handleExportData}
                          // exportData={exportData}
                        />
                      )}
                    </Col>
                    {/* {SettingsSidebar()} */}
                    {CustomViewModal()}
                  </Row>
                </div>
              </Col>
            </Row>
          </Container>
        </div>
      ) : (
        <div className="p-4">
          {TableShow ? (
            <CardBody>
              <TableForAI
                errorMessage={errorMessage}
                errorIcon={errorIcon}
                getTable={AISetTable}
                searchColumns={searchColumns}
                searchData={AIData}
                orderPermission={orderPermission}
                customerPermission={customerPermission}
                navigate={navigate}
                dispatch={dispatch}
                setRenderSimulate={setRenderSimulate}
                setLoading={setLoading}
                simulateOrPreview={simulateOrPreview}
                index={index}
                setIndex={setIndex}
                setActiveTab={setActiveTab}
                fetchCustomerDetails={fetchCustomerDetails}
                stationPermission={stationPermission}
                reservationPermission={reservationPermission}
                getCustomerData={getCustomerData}
                storeRow={storeRow}
                setDefault={setDefault}
                renderSimulate={renderSimulate}
                pagination={pagination}
                customerData={customerData}
                activeTab={activeTab}
                tabChange={tabChange}
                setOpen={setOpen}
                toggle={toggle}
                noCurrencyArray={noCurrencyArray}
                currencyArray={currencyArray}
                fetchCustomerSummaryData={fetchCustomerSummaryData}
                reservationDataArray={reservationDataArray}
                duration={duration}
                subscriptionsArray={subscriptionsArray}
                convertNumberOfDaysToMonthYear={convertNumberOfDaysToMonthYear}
                formatDate={formatDate}
                getDayDiff={getDayDiff}
                current={current}
                TableShow={TableShow}
                toggleModal={toggleModal}
                setMessageForPopUp={setMessageForPopUp}
                setCustomerId={setCustomerId}
              />
            </CardBody>
          ) : null}
        </div>
      )}
      {loading && <Loader />}
      {renderSimulate && (
        <Modal
          isOpen={renderSimulate}
          toggle={toggleModals}
          centered
          size="lg"
          className="custom-modal"
        >
          <div class="text-center w-100 modal-header d-flex">
            <h5 class="modal-title text-center flex-grow-1">{"Usage Simulate"}</h5>
            <button type="button" class="btn-close" aria-label="Close" onClick={toggleModals}></button>
          </div>
          <ModalBody>
            <Simulate setRenderSimulate={setRenderSimulate} />
          </ModalBody>
        </Modal>
      )}
    </React.Fragment>
  );
}
